export default __webpack_public_path__ + "hf-logo-2022-horiz-new-rnM.png";